import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { AppOnlinePaymentAdyenComponent } from './app-online-payment/app-online-payment-adyen/app-online-payment-adyen.component';
import { AppOnlinePaymentFailedComponent } from './app-online-payment/app-online-payment-failed/app-online-payment-failed.component';
import { AppOnlinePaymentSuccessComponent } from './app-online-payment/app-online-payment-success/app-online-payment-success.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { NgxUiLoaderModule,POSITION,PB_DIRECTION, NgxUiLoaderConfig,NgxUiLoaderHttpModule, SPINNER } from  'ngx-ui-loader';
//import {MatStepperModule} from '@angular/material/stepper';
import {MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';
import {MatGridListModule} from '@angular/material/grid-list';
import { DatePipe } from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
//mport { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {MatDialogModule} from '@angular/material/dialog';
import { AlertDialogComponent } from './alert-dialog/alert-dialog.component';
import { ItemStartdatePopupComponent } from './item-startdate-popup/item-startdate-popup.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#e0301e',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 80,
  blur: 0,
  fgsType: SPINNER.ballSpinClockwise,
  hasProgressBar:false,
  overlayColor: "rgba(40,40,40,0.12)",  
  minTime:10,  
};

@NgModule({
  declarations: [
    AppComponent,
    AppOnlinePaymentAdyenComponent,
    AppOnlinePaymentFailedComponent,
    AppOnlinePaymentSuccessComponent,
    HomeComponent,
    TermsConditionComponent,
    AlertDialogComponent,
    ItemStartdatePopupComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    MatButtonModule,
    MatGridListModule,
    //NgbModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({showForeground:true}),
    MatIconModule,
    MatDialogModule
  ],
  providers: [MatDatepickerModule,DatePipe,{provide: MAT_DATE_LOCALE, useValue: 'en-GB'}],
  bootstrap: [AppComponent]
})
export class AppModule { }
